export function checkFF(featureFlag: string): boolean {
  return window?.__APP__?.FF[featureFlag];
}
